import { useMutation } from "@tanstack/react-query";
import { forgotPassword } from ".";

export function useForgotPassword() {
  return useMutation({
    mutationKey: ["forgot_password"],
    mutationFn: forgotPassword,
  });
}
